/**
 * WordPress dependencies
 */
import { SelectControl } from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * Control to display white space options.
 *
 * @param {Object} props Component props.
 *
 * @return {Element} White space control.
 */
type WhiteSpaceControlProps = {
	readonly __next40pxDefaultSize?: boolean;
	readonly value: {
		readonly whiteSpace?: string;
	};
	readonly onChange: ( value: { whiteSpace?: string } ) => void;
	readonly size?: string;
	readonly disabled?: boolean;
};
export function WhiteSpaceControl(
	props: WhiteSpaceControlProps
): JSX.Element | false {
	const {
		/** Start opting into the larger default height that will become the default size in a future version. */
		__next40pxDefaultSize = false,
		onChange,
		value: { whiteSpace },
		disabled,
	} = props;

	const selectOptions = [
		{ value: 'normal', label: 'Normal' },
		{ value: 'pre', label: 'Pre' },
		{ value: 'nowrap', label: 'No wrap' },
		{ value: 'pre-wrap', label: 'Pre wrap' },
		{ value: 'break-spaces', label: 'Break spaces' },
		{ value: 'pre-line', label: 'Pre line' },
	];

	// Find current selection by comparing white space against options,
	// and fall back to the Default option if there is no matching option.
	const currentSelection =
		selectOptions.find( ( option ) => option.value === whiteSpace ) ||
		selectOptions[ 0 ];

	return (
		<SelectControl
			disabled={ disabled }
			className={ clsx( 'components-white-space-control', {
				'nab-components--disabled': disabled,
			} ) }
			__next40pxDefaultSize={ __next40pxDefaultSize }
			label={ _x( 'White space', 'text', 'nelio-ab-testing' ) }
			options={ selectOptions }
			value={ currentSelection?.value }
			onChange={ ( selectedValue ) =>
				onChange( { whiteSpace: selectedValue } )
			}
		/>
	);
}
